import { render, staticRenderFns } from "./LWChart2.vue?vue&type=template&id=653b9c6d&scoped=true&"
import script from "./LWChart2.vue?vue&type=script&lang=js&"
export * from "./LWChart2.vue?vue&type=script&lang=js&"
import style0 from "./LWChart2.vue?vue&type=style&index=0&id=653b9c6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b9c6d",
  null
  
)

export default component.exports